import { render, staticRenderFns } from "./BlocoTableComponent.vue?vue&type=template&id=14045ce4"
import script from "./BlocoTableComponent.vue?vue&type=script&lang=js"
export * from "./BlocoTableComponent.vue?vue&type=script&lang=js"
import style0 from "./BlocoTableComponent.vue?vue&type=style&index=0&id=14045ce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports